import { Routes, Route, Navigate } from 'react-router-dom';
import { OnboardingPage } from './pages/OnboardingPage.js';
import { InvalidLinkPage } from './pages/InvalidLinkPage.js';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<InvalidLinkPage />} />
      <Route path="/:guid" element={<OnboardingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
